import { Service } from '@usercentrics/cmp-browser-sdk';
import { useCategoryContext } from '../contexts/CategoryContext';

interface SubServiceHooks {
  onOpenSubServiceDetail: (subService: Service) => void;
  onCloseSubServiceDetail: () => void;
}

export const useSubService = (): SubServiceHooks => {
  const { selectedSubService, setSelectedSubService } = useCategoryContext();

  const onOpenSubServiceDetail = (subService: Service) => {
    setSelectedSubService(subService);
  };

  const onCloseSubServiceDetail = () => {
    if (selectedSubService) {
      setSelectedSubService(null);
    }
  };

  return {
    onCloseSubServiceDetail,
    onOpenSubServiceDetail,
  };
};
